import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type VersionsSliceState = {
  pagesLoaded: number
  scrollTopPx: number
}

export const initialState: VersionsSliceState = {
  scrollTopPx: 0,
  pagesLoaded: 1
}

export const slice = createSlice({
  name: 'versions',
  initialState,
  reducers: {
    setScrollTopPx: (state, action: PayloadAction<number>) => {
      state.scrollTopPx = action.payload
    },
    setPagesLoaded: (state, action: PayloadAction<number>) => {
      state.pagesLoaded = action.payload
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
